import React from 'react';
import { FeatureAppLoader } from '@feature-hub/react';
import {
  LayerCloseHandleV2,
  LayerRenderOptionsV2,
} from '@volkswagen-onehub/layer-manager';
import { UsedVehicle } from '../../typing/used-inventory';
import { CloseButton } from '@vw-marketing/us-components';
import { StyledCloseButtonContainer } from './styles';

export interface LayerContentState {
  readonly text: string;
  readonly index: number;
  readonly canOpenInteraction: boolean;
  readonly canOpenFocus: boolean;
  readonly canOpenAlert: boolean;
  readonly canOpenContent: boolean;
  readonly canOpenDisclaimer: boolean;
  readonly userCloseable?: boolean;
  readonly canOpenFullscreenLayer?: boolean;
  readonly canOpenCustomLayer?: boolean;
}

export interface PaymentContainerProps {
  readonly close: LayerCloseHandleV2<void>;
  readonly state: LayerContentState;
  readonly options: LayerRenderOptionsV2;
  readonly infoPrefix?: string;
  vehicleModel?: UsedVehicle;
  layerSetup?: any;
  zipcode?: string
}

const PaymentContainer = ({
  close,
  vehicleModel,
  layerSetup,
  zipcode
}: PaymentContainerProps) => {
  const {
    featureAppId,
    name: featureAppName,
    baseUrl,
    src,
    serverSrc,
    config,
    css,
  } = layerSetup;

  return (
    <>
      <StyledCloseButtonContainer>
        <CloseButton onClick={() => close()} />
      </StyledCloseButtonContainer>
      <FeatureAppLoader
        featureAppId={featureAppId}
        featureAppName={featureAppName}
        baseUrl={baseUrl}
        src={src}
        serverSrc={serverSrc}
        css={css}
        config={{
          ...config,
          vin: vehicleModel?.vin,
          model: vehicleModel?.model,
          used:true,
          zip:zipcode
        }}
      />
    </>
  );
};

export default PaymentContainer;
